<template>
    <section id="unique-approach" class="mb-5">
        <div class="unique-approach-1 pt-md-5 pb-md-5 pt-3 pb-3 bg-top">
            <div class="container">
                <h2>Success begins with a strong foundation.</h2>

                <div class="research">
                    <div class="row">
                        <div class="col-md-8">
                            <h3>Research</h3>
                            <p>Competitor and industry analysis gives our team the big picture for both your business and your customers. At Empower Direct, we pair that analysis with an operational and marketing deep-dive to create a solid, thorough approach to all our work and recommendations.</p>
                        </div>
                        <div class="col-md-4">
                            <figure>
                                <img alt="" src="../assets/research.gif">
                            </figure>
                        </div>
                    </div>
                </div>

                <div class="execution">
                    <div class="row">
                        <div class="col-md-4">
                            <figure>
                                <img alt="" src="../assets/execution.gif">
                            </figure>
                        </div>
                        <div class="col-md-8">
                            <h3>Execution</h3>
                            <p>In today’s digital world, you need an online presence that speaks to your customers and works for your business. By creating unique, custom websites, apps, and other digital assets, our team of global designers and developers ensure the face of your company is as polished and strong as the marketing strategy we put behind it.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="unique-approach-2 pt-md-5 pb-md-5 pt-3 pb-3 bg-bottom">
            <div class="container">
                <h2>We’re not like other companies.</h2>

                <div class="row pt-5 pb-5">
                    <div class="col-md-2">
                        <figure>
                            <img src="../assets/lead-generation.svg" alt="">
                        </figure>
                    </div>
                    <div class="col-md-10">
                        <h4>Lead Generation</h4>
                        <p>At Empower Direct, we utilize various social media channels, search engines, ad networks, and other pay-per-click platforms to deliver the qualified leads your business wants and needs. We’re so good at generating leads and delivering results we only charge you for the leads you get! Stop paying for junk marketing services - pay for results. That’s the Empower Direct way.</p>
                    </div>
                </div>

                <div class="row pt-5 pb-5">
                    <div class="col-md-2">
                        <figure>
                            <img src="../assets/data-driven-marketing.svg" alt="">
                        </figure>
                    </div>
                    <div class="col-md-10">
                        <h4>Data-Driven Marketing</h4>
                        <p>We believe in data-driven approaches to marketing that update in real-time. That’s why the Empower Direct team analyzes your customer interactions 24/7 with an international team of experts. Assessing analytics and making real-time updates ensures nothing slips through the cracks and your campaigns get smarter with every click. Contact us today so we can help your business market smarter.</p>
                    </div>
                </div>

                <div class="row pt-5 pb-5">
                    <div class="col-md-2">
                        <figure>
                            <img src="../assets/business-strategy-development.svg" alt="">
                        </figure>
                    </div>
                    <div class="col-md-10">
                        <h4>Business Strategy & Development</h4>
                        <p>A strong start requires a strong finish. Following every campaign, Empower Direct delivers a full report to your business for a clear picture of what’s working and potential sales barriers. These data-driven exports are paired with qualitative insights to create the roadmaps that keep our long-time clients on the path to success. Create a comprehensive long-term strategy for growth and increase market share today!</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'UniqueApproach',
    };
</script>

<style lang="scss">
    #unique-approach {
        .unique-approach-1 {
            .research {
                img {
                    margin-right: -3rem;
                }
            }
            .execution {
                margin-top: -2rem;

                .col-md-8 {
                    padding-top: 2rem;
                }

                img {
                    margin-left: -3rem;
                }
            }
        }

        .unique-approach-2 {
            img {
                max-height: 130px;
            }
        }
        @media (max-width: 991px) {
            .unique-approach-1 {
                figure {
                    display: none;
                }
                h3::after {
                    content: '';
                    display: inline-block;
                    width: 32px;
                    height: 32px;
                    background-repeat: no-repeat;
                    background-size: contain;
                    margin: -4px 0 -4px 1rem;
                }
                .research {
                    h3::after {
                        background-image: url('../assets/research-min.svg');
                    }
                }
                .execution {
                    h3::after {
                        background-image: url('../assets/execution-min.svg');
                    }
                }
            }
        }
    }
</style>
